import React, { Component } from 'react';
import styles from './TextInput.scss';
import { noop, debounce } from 'lodash';

class TextInputIndustryMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: []
    };
  }

  onTextChange = event => {
    const { onChange } = this.props;
    onChange(event.target.value);
    this.loadOptions(event.target.value);
  };

  onKeyUp = event => {
    if (event.which === 13) {
      this.ref.blur();
    }
  };

  fetchIndustries = debounce(async term => {
    const { industriesFetcher } = this.props;
    const fetchedIndustries = await industriesFetcher(term);
    this.setState(() => {
      return {
        options: fetchedIndustries
      };
    });
  }, 200);

  loadOptions = term => {
    this.fetchIndustries(term);
  };

  getAutocomplete = async term => {
    const { industriesFetcher } = this.props;
    return industriesFetcher(term);
  };

  componentDidUpdate(prevProps) {
    const { isHidden: isHiddenCurrent } = this.props;
    const { isHidden } = prevProps;
    if (isHidden === true && isHiddenCurrent === false) {
      this.ref.focus();
    }
  }

  render() {
    const { value, label, className, placeholder, onFocus = noop, autoFocus, onIndustrySelected } = this.props;
    const { options } = this.state;
    const listOfOptions = options
      ? options.map((industry, index) => {
          return (
            <div className={styles.option} onClick={() => onIndustrySelected(industry)} key={index}>
              {industry.label}
            </div>
          );
        })
      : [];
    return (
      <div className={styles.container}>
        {!!label && <div className={styles.label}>{label}</div>}
        <div className={styles.textInput}>
          <input
            placeholder={placeholder}
            ref={ref => (this.ref = ref)}
            className={className}
            autoFocus={autoFocus}
            type="text"
            value={value}
            onChange={this.onTextChange}
            onKeyUp={this.onKeyUp}
            onFocus={onFocus}
            maxLength={30}
          />
        </div>
        <div onScroll={e => e.stopPropagation()} className={styles.listOfIndustriesContainer}>
          {listOfOptions}
        </div>
      </div>
    );
  }
}

export default TextInputIndustryMobile;
